var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["Action"] = "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-cogvio-900 text-white text-base font-medium transition duration-200 ease-in-out hover:bg-cogvioBlue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm";
    ButtonStyle["Cancel"] = "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base font-medium text-gray-700 transition duration-200 ease-in-out hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm";
    ButtonStyle["Link"] = "px-4 py-2 text-sm font-medium text-cogvio-700 transition duration-200 ease-in-out underline hover:no-underline";
})(ButtonStyle || (ButtonStyle = {}));
export var Button = function (_a) {
    var children = _a.children, _b = _a.style, style = _b === void 0 ? ButtonStyle.Action : _b, props = __rest(_a, ["children", "style"]);
    return (<button {...props} className={style.valueOf()}>
		{children}
	</button>);
};
